import { render, staticRenderFns } from "./UserListComponent.vue?vue&type=template&id=25506448&"
import script from "./UserListComponent.vue?vue&type=script&lang=js&"
export * from "./UserListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports